import { IClassname } from '@/lib/shared/model/classname';

export const AirConditioner = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.58187 2.58203H29.4181C29.4181 2.58203 30.696 2.58203 30.696 3.85995V15.3612C30.696 15.3612 30.696 16.6391 29.4181 16.6391H2.58187C2.58187 16.6391 1.30396 16.6391 1.30396 15.3612V3.85995C1.30396 3.85995 1.30396 2.58203 2.58187 2.58203Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.85986 16.6388V15.3609C3.85986 15.022 3.9945 14.697 4.23416 14.4573C4.47381 14.2176 4.79886 14.083 5.13778 14.083H26.8624C27.2013 14.083 27.5263 14.2176 27.766 14.4573C28.0056 14.697 28.1403 15.022 28.1403 15.3609V16.6388"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1377 6.41602H26.8623"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1377 10.249H26.8623"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.7767 19.1943C5.08202 19.8831 4.633 20.7812 4.49878 21.7502C4.633 22.7192 5.08202 23.6172 5.7767 24.306"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.77661 29.4183C6.47129 28.7295 6.9203 27.8315 7.05453 26.8625C6.9203 25.8935 6.47129 24.9954 5.77661 24.3066"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2232 19.1943C25.5286 19.8831 25.0795 20.7812 24.9453 21.7502C25.0795 22.7192 25.5286 23.6172 26.2232 24.306"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2234 29.4183C26.9181 28.7295 27.3671 27.8315 27.5013 26.8625C27.3671 25.8935 26.9181 24.9954 26.2234 24.3066"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 20.4727V28.1402"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6799 22.3896L19.32 26.2234"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.32 22.3896L12.6799 26.2234"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
